export default __webpack_public_path__ + "static/media/beaver-step-3.61905dc8.svg";